import { ExternalTheme } from "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../constants/create-theme/create-theme.js";
import "@mui/material/styles";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/shadows/shadows.js";
import "@mui/material";
import "../../../../../themes/typography/typography.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../../../themes/alert/alert.js";
import "react/jsx-runtime";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
const root = (isOpened) => ({
  backgroundColor: ExternalTheme.palette.common.white,
  transition: "width 0.3s ease-in-out",
  width: isOpened ? "100vw" : 0,
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  position: "fixed",
  zIndex: 101,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: "auto"
});
const accordionSummary = {
  padding: 0
};
const header = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: 72,
  px: "16px",
  mb: "24px",
  border: "0.5px",
  borderStyle: "solid",
  borderColor: "grey.300"
};
const logo = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: 72
};
const closeButton = {
  color: "primary.600",
  width: 24,
  height: 24,
  mr: "16px",
  svg: {
    width: 24,
    height: 24
  }
};
const accordionWrapper = {
  boxShadow: "none",
  "::before": {
    height: 0
  },
  "&.Mui-expanded": {
    backgroundColor: ExternalTheme.palette.common.white,
    color: "primary.600",
    margin: 0
  }
};
const accordionHeader = {
  ".MuiAccordionSummary-content.Mui-expanded": {
    my: "16px"
  }
};
const expandButton = (isExpanded, isMenuItemSelected) => ({
  color: isExpanded || isMenuItemSelected ? "primary.600" : "grey.800",
  transform: isExpanded ? "rotate(180deg)" : "none",
  transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
});
const accordionContent = {
  backgroundColor: "grey.50",
  padding: 0
};
const category = (isExpanded, isMenuItemSelected) => ({
  ...ExternalTheme.typography["Lato Emphasized 1"],
  color: isExpanded || isMenuItemSelected ? "primary.600" : "grey.800"
});
const subCategory = (isFirst) => ({
  ...ExternalTheme.typography["Lato Caption Small Bold"],
  px: "16px",
  paddingTop: isFirst ? "8px" : "16px",
  paddingBottom: "8px",
  color: "primary.600"
});
const link = (isItemSelected, alignOnBottom) => ({
  display: "block",
  ...alignOnBottom ? ExternalTheme.typography["Lato Body 2"] : ExternalTheme.typography["Lato Body 1"],
  color: isItemSelected ? "primary.600" : "grey.800"
});
const firstLevelLink = (isItemSelected) => ({
  p: "16px",
  "& p": {
    ...ExternalTheme.typography["Lato Emphasized 1"],
    color: isItemSelected ? "primary.600" : "grey.800"
  },
  "&:hover": {
    backgroundColor: "grey.200"
  }
});
const navigationFooter = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-end",
  flex: 1,
  marginTop: "20px"
};
const langAndLinksAccordion = {
  width: "100%",
  boxShadow: "none",
  "::before": {
    height: 0
  }
};
const langAndLinksAccordionContent = {
  backgroundColor: "grey.50",
  padding: 0
};
const langAndLinksWrapper = (isExpanded) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  ...ExternalTheme.typography["Lato Emphasized 1"],
  color: isExpanded ? "primary.600" : "grey.800",
  paddingInline: "16px"
});
const langLink = (isExpanded = false, padding = true) => ({
  display: "flex",
  margin: 0,
  padding: 0,
  outline: 0,
  backgroundColor: "unset",
  border: 0,
  "&:focus-visible": {
    outline: "-webkit-focus-ring-color auto 1px"
  },
  ...ExternalTheme.typography["Lato Body 1"],
  color: isExpanded ? "primary.600" : "grey.800",
  p: padding ? "16px" : 0,
  "&:hover": {
    backgroundColor: padding ? "grey.200" : ExternalTheme.palette.common.white
  },
  width: "100%"
});
const countryFlag = {
  width: 24,
  height: 24,
  mr: "16px",
  borderRadius: "50%"
};
const langTick = (theme2) => ({
  width: 24,
  height: 24,
  ml: "16px",
  fill: theme2.palette.highlight1[500]
});
const ctaButton = {
  pb: "40px",
  pt: "24px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "18px"
};
const buttonsContainer = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  px: "16px",
  width: "100%",
  flex: 1
};
const inlineButtonContainer = {
  paddingInline: "16px"
};
export {
  accordionContent,
  accordionHeader,
  accordionSummary,
  accordionWrapper,
  buttonsContainer,
  category,
  closeButton,
  countryFlag,
  ctaButton,
  expandButton,
  firstLevelLink,
  header,
  inlineButtonContainer,
  langAndLinksAccordion,
  langAndLinksAccordionContent,
  langAndLinksWrapper,
  langLink,
  langTick,
  link,
  logo,
  navigationFooter,
  root,
  subCategory
};
